import type React from 'react';

import { Text } from '@change/ds-core-ui';

import type { PreviewEmailModalBodyProps } from '../../../../types';
import { PreviewEmailContentBox } from '../PreviewEmailContentBox';
import { PreviewEmailPetitionTitle } from '../PreviewEmailPetitionTitle';
import { PreviewEmailSenderInfo } from '../PreviewEmailSenderInfo';

type PreviewEmailModalBodyPropsReskin = Omit<PreviewEmailModalBodyProps, 'onClose'>;

export const PreviewEmailModalBody: React.FC<PreviewEmailModalBodyPropsReskin> = ({
	emailTitle,
	emailContent,
	petitionTitle,
	userName,
	imageDataUrl,
}) => {
	return (
		<div className="bordered p-4 md:p-6">
			<div className="flex flex-col">
				<div>
					<Text as="h2" className="font-(family-name:Helvetica-Neue) mt-0 mb-4 font-normal" variant="heading">
						{emailTitle}
					</Text>
				</div>
				<PreviewEmailSenderInfo userName={userName} />
				<PreviewEmailPetitionTitle title={petitionTitle} userName={userName} />
				<PreviewEmailContentBox subject={emailTitle} body={emailContent} imageDataUrl={imageDataUrl} />
			</div>
		</div>
	);
};
